module.exports = __webpack_public_path__ + "static/media/top-banner.b803bae2.png";